const moduleRoute = {
  path: '/login',
  component: () => import('@/views/Login')
}

export default router => {
  router.addRoute(moduleRoute)
}
